module.exports = __webpack_public_path__ + "img/world-black.d0771fc4.svg";